import { loyaltyService } from '@/infrastructure/Factory'

const DNA_PREFIX = 'DNA-'

export default class DnaService {
  async getDna() {
    try {
      return await loyaltyService.getUserDna()
    } catch (error) {
      return {}
    }
  }

  dnaParameterString(dnaProperties) {
    return DNA_PREFIX + dnaProperties.map(elem => elem.code).join('-')
  }

  async getDnaString(sliderWithDna) {
    let dnaString = ''
    const hasToRequestUserDna = global.ConfigDynamic.isEnabled(global.ConfigDynamicKey.OFFERS_DNA_PERSONALIZATION_ACTIVE) &&
    global.AuthDispatcher.isLogged() && sliderWithDna
    if (hasToRequestUserDna) {
      const userDna = await this.getDna()

      dnaString = userDna.properties
        ? this.dnaParameterString(userDna.properties)
        : ''
    }
    return dnaString
  }
}
